<template>
  <app-dialog v-model="dialogIsOpen" :title="currentTitle">
    <component :is="formSteps[currentStep].component" v-bind="{ ...formSteps[currentStep].props }" @next-step="onNextStep" @prev-step="onPrevStep" @login="$emit('login')" />
  </app-dialog>
</template>

<script>
import ForgotPasswordForm from '@/components/authentication/ForgotPasswordForm.vue'
import OTPForm from '@/components/authentication/OTPForm.vue'
import ResetPasswordForm from '@/components/authentication/ResetPasswordForm.vue'
import PasswordResetSuccessful from '@/components/authentication/PasswordResetSuccessful.vue'
import { localeHelper } from '@/utils'

export default {
  components: {
    ForgotPasswordForm,
    OTPForm,
    ResetPasswordForm,
    PasswordResetSuccessful
  },

  props: ['value'],

  data() {
    return {
      currentStep: 0,
      formSteps: [
        { component: ForgotPasswordForm, title: localeHelper.getMessage('label.forgotPassword') },
        { component: OTPForm, title: localeHelper.getMessage('label.enterOtp'), props: { otpType: 'RESET_PASSWORD' } },
        { component: ResetPasswordForm, title: localeHelper.getMessage('label.resetPassword'), props: { reset: true } },
        { component: PasswordResetSuccessful, title: localeHelper.getMessage('label.resetPasswordComplete') }
      ]
    }
  },

  computed: {
    dialogIsOpen: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.currentStep = 0
      }
    },

    currentTitle() {
      return this.formSteps[this.currentStep].title
    }
  },

  methods: {
    close() {
      this.$nextTick(() => {
        const defaultForm = {
          loginId: ''
        }
        this.form = { ...defaultForm }
      })
      this.$emit('input', false)
    },

    onNextStep() {
      if (this.currentStep === this.formSteps.length - 1) {
        this.close()
        return
      }
      this.currentStep++
    },

    onPrevStep() {
      if (this.currentStep === 0) {
        this.$root.$app.openLoginDialog()
      } else {
        this.currentStep--
      }
    }
  }
}
</script>
